import { COMPANY_ROUTES } from 'core/constants/companyRoutes';
import { CompanyTabEnum } from 'core/enum/companyTab';
import { ICompanyHeaderItems } from 'core/interface/headerItems';

const companyHeader: ICompanyHeaderItems[] = [
  {
    isActive: false,
    title: 'Find Candidates',
    path: COMPANY_ROUTES.FIND_CANDIDATES,
    value: CompanyTabEnum.FIND_CANDIDATES
  },
  {
    isActive: false,
    title: 'Job Posts',
    path: COMPANY_ROUTES.JOB_POSTS,
    value: CompanyTabEnum.JOB_POSTS
  },
  {
    isActive: false,
    title: 'Culture Profiles',
    path: COMPANY_ROUTES.CULTURE_PROFILES,
    value: CompanyTabEnum.CULTURE_PROFILES
  },
  {
    isActive: false,
    title: 'Candidate overview',
    path: COMPANY_ROUTES.CANDIDATE_OVERVIEW,
    value: CompanyTabEnum.CANDIDATE_OVERVIEW
  },
  {
    isActive: false,
    title: 'Career page',
    path: COMPANY_ROUTES.CAREER_PAGE,
    value: CompanyTabEnum.CAREER_PAGE
  }
];

export { companyHeader };
